var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Time Circle 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.96852 1.83568C5.29197 1.57692 5.34441 1.10495 5.08565 0.781506C4.82689 0.45806 4.35493 0.405619 4.03148 0.664376L1.53148 2.66438C1.20803 2.92313 1.15559 3.3951 1.41435 3.71855C1.67311 4.042 2.14507 4.09444 2.46852 3.83568L4.96852 1.83568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9685 0.664376C17.6451 0.405619 17.1731 0.45806 16.9143 0.781506C16.6556 1.10495 16.708 1.57692 17.0315 1.83568L19.5315 3.83568C19.8549 4.09444 20.3269 4.042 20.5857 3.71855C20.8444 3.3951 20.792 2.92313 20.4685 2.66438L17.9685 0.664376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 1.25003C5.06294 1.25003 0.25 6.06297 0.25 12C0.25 17.9371 5.06294 22.75 11 22.75C16.9371 22.75 21.75 17.9371 21.75 12C21.75 6.06297 16.9371 1.25003 11 1.25003ZM11.75 8.00003C11.75 7.58582 11.4142 7.25003 11 7.25003C10.5858 7.25003 10.25 7.58582 10.25 8.00003V10.7255C10.25 11.2593 10.25 11.7133 10.2871 12.0902C10.3267 12.4916 10.4125 12.8636 10.6184 13.2203C10.8244 13.577 11.1037 13.8374 11.4315 14.0723C11.7393 14.2929 12.1325 14.5199 12.5948 14.7868L13.2232 15.1496C13.5819 15.3567 14.0406 15.2337 14.2477 14.875C14.4548 14.5163 14.3319 14.0576 13.9731 13.8505L13.375 13.5052C12.8744 13.2161 12.5459 13.0256 12.3054 12.8531C12.0782 12.6903 11.9795 12.5777 11.9175 12.4703C11.8555 12.3629 11.8073 12.2212 11.7799 11.943C11.7508 11.6484 11.75 11.2687 11.75 10.6906L11.75 8.00003Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardLog);
export default __webpack_public_path__ + "static/media/reward-log.6b2144abda20db535328656656f28f45.svg";
export { ForwardRef as ReactComponent };